import { PRODUCT_FORM_MESSAGES, ProductFormMessages } from "./product-form.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { SKU_FORM_MESSAGES, SkuFormMessages } from "../sku/sku-form.messages";
import { SKU_TABLE_MESSAGES, SkuTableMessages } from "../sku/sku-table.messages.";

export type ProductFormPageMessages = ActionButtonMessages &
  SkuTableMessages &
  ProductFormMessages &
  SkuFormMessages &
  PopoverMessages &
  SidebarMessages & {
    breadCrumbTitle: string;
    editTitle: string;
    createTitle: string;
    cardTitle: string;

    //Tab Titles
    productInfoTabLabel: string;
    productSkuTabLabel: string;
    kitTabLabel: string;

    // Product save messages
    productSaveSuccess: string;
    productSaveError: string;
    productMustBeSavedFirst: string;
    waitForImageUpload: string;
    imageUploadSuccess: string;
    imageUploadError: string;
    errorProductMustHaveTitle: string;
    productMustHaveCodeAndTitle: string;
  };

export const PRODUCT_FORM_PAGE_MESSAGES: ProductFormPageMessages = {
  // Page titles
  breadCrumbTitle: "Produtos",
  editTitle: "Editar Produto",
  createTitle: "Criar Produto",
  cardTitle: "Detalhes do Produto",

  //Tab Titles
  productInfoTabLabel: "Informações",
  productSkuTabLabel: "SKU",
  kitTabLabel: "KIT",

  // Product save messages
  productSaveSuccess: "Produto salvo com sucesso!",
  productSaveError: "Erro ao salvar produto!",
  productMustBeSavedFirst: "O produto deve ser salvo antes de adicionar SKUs",
  waitForImageUpload: "Aguarde o término do envio das imagens",
  imageUploadSuccess: "Imagens enviadas com sucesso!",
  imageUploadError: "Erro ao enviar imagens!",
  errorProductMustHaveTitle: "O produto deve ter um título antes de adicionar SKUs",
  productMustHaveCodeAndTitle: "Preencha código e título do produto antes de adicionar imagens",

  ...SKU_FORM_MESSAGES,
  ...PRODUCT_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SKU_TABLE_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...POPOVER_MESSAGES,
};
